import { emptyObj } from 'util/objects'

export function selectBase(state) {
  return state.ticketing || emptyObj
}
